import { useGetBrivoConnection } from '@/api/property-keyless/brivo/get-brivo-connection'

import { BrivoConnectionFormValues, brivoDefaultValues } from './brivo.schema'

export const useBrivoConnection = (buildingId: number) => {
  const { data, isLoading, isSuccess } = useGetBrivoConnection({ buildingId })

  // Note: mirrors the legacy check — Brivo is only "configured" once a clientSecret has
  // actually been saved server-side. A never-connected building 404s silently (no error UI).
  // Gated on `isSuccess`, not just `data`, so a later failed refetch (real backend error) also
  // falls back to "not configured" instead of showing stale "connected" data.
  const isConfigured = isSuccess && Boolean(data?.clientSecret)

  const values: BrivoConnectionFormValues = {
    ...brivoDefaultValues,
    clientId: data?.clientId ?? '',
    clientSecret: data?.clientSecret ?? '',
  }

  return { isConfigured, isLoading, values }
}
